import React, { FC } from 'react';

import ActionButton from '../ActionButton';
import useAsyncAction from '../../hooks/useAsyncAction';

interface IGetHintButtonProps {
  cps?: string;
  linked?: boolean;
  hinteable?: boolean;
  onGetHint?: () => void | Promise<void>;
}

const HINT_CP = 'prime';

const GetHintButton: FC<IGetHintButtonProps> = ({ cps, linked, hinteable, onGetHint }) => {
  const { isLoading, errorMessage, run } = useAsyncAction(
    onGetHint,
    'Error al obtener el hint. Por favor, intenta nuevamente.'
  );

  if (cps !== HINT_CP || !linked || !hinteable) return null;

  return (
    <>
      <ActionButton
        label="Obtener Hint"
        onClick={run}
        isLoading={isLoading}
        disabled={!onGetHint}
      />
      {errorMessage && (
        <p className="error-message">{errorMessage}</p>
      )}
    </>
  );
};

export default GetHintButton;
